import React from 'react';
import { MapPin } from 'lucide-react';

const RADIUS_OPTIONS = [5, 10, 25, 50, 100];

export function AroundMeRadiusControl({ active, radiusKm, onActivate, onRadiusChange }) {
  const changeRadius = (event) => {
    onRadiusChange(Number(event.target.value));
    onActivate();
  };

  return (
    <div className={`collab-mode__around${active ? ' is-active' : ''}`} role="group" aria-label="Around me distance">
      <button type="button" aria-pressed={active} onClick={onActivate}>
        <MapPin size={15} /> Around me
      </button>
      <select value={radiusKm} onChange={changeRadius} aria-label="Search radius">
        {RADIUS_OPTIONS.map((distance) => <option key={distance} value={distance}>{distance} km</option>)}
      </select>
    </div>
  );
}

export default AroundMeRadiusControl;
